import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "antd";
import {
  filterFrontDoorProductsForOrg,
  isProductHeld,
  resolvePlanProductCopy,
} from "util/planEntitlements";
import styles from "./style.module.scss";

/**
 * Discover-only front-door products (not already held).
 * Held Survey / etc. live under PlanActiveSubscriptions.
 */
const PlanFrontDoorProducts = ({
  products = [],
  entitlements = [],
  onRequestProduct,
  loading,
  isEnterprise = false,
}) => {
  const { t } = useTranslation();
  const frontDoor = filterFrontDoorProductsForOrg(products, entitlements);
  const discover = frontDoor.filter((product) => {
    const key = product.product_key || product.key;
    return !isProductHeld(key, entitlements);
  });

  if (!loading && !discover.length) {
    return null;
  }

  return (
    <div className={styles.content}>
      <h3 className={styles.header}>{t("settings.plan_discover_title")}</h3>
      <p className={styles.sectionHint}>{t("settings.plan_discover_hint")}</p>
      {loading ? (
        <p className={styles.sectionHint}>{t("settings.plan_loading")}</p>
      ) : null}
      <div className={styles.productGrid}>
        {discover.map((product) => {
          const key = product.product_key || product.key;
          const copy = resolvePlanProductCopy(key, product, t);

          return (
            <div key={key} className={styles.productCard}>
              <div className={styles.productCardHeader}>
                <h4 className={styles.productCardTitle}>{copy.name}</h4>
              </div>
              {copy.description ? (
                <p className={styles.productCardDesc}>{copy.description}</p>
              ) : null}
              <div className={`${styles.btn} ${styles.btnBuy}`}>
                <Button
                  onClick={() =>
                    onRequestProduct({
                      productKey: key,
                      productName: copy.name,
                    })
                  }
                >
                  {isEnterprise
                    ? t("sonic_prospect.plans_contact_sales")
                    : t("settings.plan_product_activate")}
                </Button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PlanFrontDoorProducts;
